export default "__VITE_PUBLIC_ASSET__78d25557__"